import { creditCardDetailsEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { GridOffset } from "@insite/mobius/GridContainer";
import { TYPOGRAPHY } from "@store/theme/common/design";
import { css } from "styled-components";

Object.assign(creditCardDetailsEntryStyles, {
    creditCardDetailsContainer: {
        gap: 10,
        css: css`
            ${GridOffset} {
                width: calc(100% + 10px);
            }
        `,
    },
    creditCardDetailsHeading: {
        variant: "h3",
        size: 18,
        css: css`
            font-size: ${TYPOGRAPHY.size.large} !important;
            padding-bottom: 0 !important;
            margin-bottom: 15px !important;
        `,
    },
    cardTypeTokenExLabel: {
        variant: "h3",
        size: 18,
        css: css`
            margin-top: 30px !important;
            margin-bottom: 20px !important;
            font-size: ${TYPOGRAPHY.size.large} !important;
        `,
    },
    cardTypeTokenExText: {
        css: css`
            margin-bottom: 10px;
        `,
    },
    cardNumberTokenExFrame: {
        cssOverrides: {
            inputSelect: `
                border-width: 2px;
            `,
        },
    },
    securityCodeTokenExFrame: {
        cssOverrides: {
            inputSelect: `
                border-width: 2px;
            `,
        },
    },
});
